let langFileds = require.context('./config', false, /\.js$/);

let regExp = /\.\/([^\.\/]+)\.([^\.]+)$/; //正则用于匹配 ./en.js中的'en'

// regExp.exec('./en.js')

let messages = {}; // 声明一个数据模型，对应i18n中的message属性

langFileds.keys().forEach(key => {
    let prop = regExp.exec(key)[1] //正则匹配en|zh这样的值
    // messages[prop]相当于 messages['en'] = {table:{...}}
    messages[prop] = langFileds(key).default
})
let locale = localStorage.getItem('lang') || window.SITE_CONFIG.defaultLanguage;//设置语言(默认简体中文):[en, zh-CN, ]
export default messages[locale];




// WEBPACK FOOTER //
// ./src/language/index.js